export const platforms = [
  {
    name: "Airbnb",
    description: "Import your listings from Airbnb",
    id: "airbnb",
    docsUrl: "https://www.airbnb.com/partner"
  },
  {
    name: "Booking.com",
    description: "Sync your Booking.com properties",
    id: "booking",
    docsUrl: "https://connect.booking.com"
  },
  {
    name: "VRBO",
    description: "Connect your VRBO listings",
    id: "vrbo",
    docsUrl: "https://developer.expediagroup.com/vrbo"
  },
  {
    name: "TripAdvisor",
    description: "Import TripAdvisor rentals",
    id: "tripadvisor",
    docsUrl: "https://developer.tripadvisor.com/partner"
  },
  {
    name: "Expedia",
    description: "Connect your Expedia listings",
    id: "expedia",
    docsUrl: "https://developer.expediagroup.com"
  },
  {
    name: "HomeAway",
    description: "Sync HomeAway properties",
    id: "homeaway",
    docsUrl: "https://developer.expediagroup.com/homeaway"
  }
];